//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import Badge, { BadgeType } from '@components/atoms/badge/Badge';
import { MediaAtomPositionMixins } from '@components/atoms/media/MediaAtomPositionMixins';
import { getRgbaForThemeHex } from '@utils/getRgbaForThemeHex';

interface BadgeOverlayProps {
  badgeText: string;
}

export const UiaBadgeOverlay = ({ badgeText }: BadgeOverlayProps) => {
  return (
    <OverlayContainer>
      <Badge text={badgeText} type={BadgeType.Secondary} />
    </OverlayContainer>
  );
};

// matches the overlay container used in PrimaryActionOverlayButton
const OverlayContainer = styled.div(
  ({ theme }) => `
    ${MediaAtomPositionMixins.Cover};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings[2]};
    align-items: center;
    justify-content: center;
    background-color: ${getRgbaForThemeHex(theme.colors.black, 0.5)};
    color: ${theme.colors.white};
  `,
);
